import { UI, VStack } from '@genial/components';
import React from 'react';

import { CustomerSentOrdersResponseNormalized } from '../../../../../../../store/customerDetail/types';

export namespace EmptyOrdersTypes {
  export interface Props {
    isLoading?: boolean;
    data: CustomerSentOrdersResponseNormalized[];
  }
}

export const EmptyOrders: React.FC<EmptyOrdersTypes.Props> = ({ isLoading, data }) => {
  if (isLoading || data.length > 0) {
    return null;
  }

  return (
    <VStack
      alignItems="center"
      justifyContent="center"
      flex={1}
      space="inline.xxxs"
      py="stack.huge">
      <UI.Illustration name="NotEmptyIllustration" testID="empty-illustration" />
      <VStack space="inline.quarck">
        <UI.Text variant="semibold" textAlign="center" color="neutral.black">
          Você ainda não possui ordens.
        </UI.Text>
        <UI.Text color="neutral.black" textAlign="center">
          Você ainda não possui ordens para visualização de detalhes.
        </UI.Text>
      </VStack>
    </VStack>
  );
};
